import gsap from 'gsap'

export const transition = () => {

  const bars = document.querySelectorAll('.transition__bar span')
  const timeline = gsap.timeline({ repeat: -1, repeatDelay: 1 })

  timeline.fromTo(bars, { height: '0', bottom: 0, top: 'auto' }, {
    duration: 1.1,
    height: '100%',
    stagger: 0.04,
    ease: 'power2.inOut'
  })

  timeline.set(bars, { bottom: 'auto', top: 0 })

  timeline.fromTo(bars, { height: '100%',  }, {
    duration: 1.1,
    height: '0',
    stagger: 0.04,
    ease: 'power2.inOut'
  })

  timeline.set(bars, { bottom: 0, top: 'auto' })
  
}

export default () => { }
